import { useState, useEffect } from "react";
import axios from "axios";
import "@/App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Social Icons
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const SpotifyIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);

const AppleMusicIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const ExternalLinkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="external-icon">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"/>
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState('home');
  const [email, setEmail] = useState('');
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // Image URLs
  const jlLogoUrl = "https://customer-assets.emergentagent.com/job_personality-animator-1/artifacts/gueaa4md_IMG_6227.PNG";
  const goldDiggerGirlArtwork = "https://customer-assets.emergentagent.com/job_personality-animator-1/artifacts/niwnne89_Jay%20London%20-%20Gold%20Digger%20Girl%20-%20Cover-%203000x3000.jpg";
  const tshirtImage = "https://customer-assets.emergentagent.com/job_personality-animator-1/artifacts/el7rulmm_129E8BFC-321D-4565-A089-6EB403D52276.PNG";
  const songPreviewClip = "https://customer-assets.emergentagent.com/job_personality-animator-1/artifacts/2uc1mst2_Gold%20Digger%20Girl%20-%20Jay%20London%20-%20Chorus%3Ahook.MP4";
  const jayLondonKeysImage = "https://customer-assets.emergentagent.com/job_personality-animator-1/artifacts/28o3x3r3_Jay%20London%20on%20Keys.png";
  
  // External logos
  const londonLiningsLogo = "https://londonlinings.com.au/wp-content/uploads/2025/09/LL-LOGO-A-1.png";
  const serveAILogo = "https://serveai.com.au/wp-content/uploads/2025/07/fulllogo_nobuffer-1024x226.png";
  const serveCRMLogo = "https://serveai.com.au/wp-content/uploads/2025/07/SERVE-CRM-TRANSPARENT-LOGO.png";
  
  // London Linings images
  const epoxyFloorImage = "https://www.londonlinings.com.au/wp-content/uploads/2025/09/porche-cayenne.jpg";
  const epoxyBeforeAfter = "https://www.londonlinings.com.au/wp-content/uploads/2025/09/LL-van-and-house-1-scaled.jpg";
  const commercialEpoxy = "https://www.londonlinings.com.au/wp-content/uploads/2025/09/Commercial-Green.jpg";
  const grindAndSeal = "https://www.londonlinings.com.au/wp-content/uploads/2025/09/grind-and-seal-2.jpg";

  const submitLead = async (emailValue, source) => {
    try {
      const response = await axios.post(`${API}/leads`, {
        email: emailValue,
        source: source
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting lead:', error);
      throw error;
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (email && !isSubmitting) {
      setIsSubmitting(true);
      try {
        await submitLead(email, 'website_main');
        setEmailSubmitted(true);
      } catch (error) {
        alert('Something went wrong. Please try again.');
      }
      setIsSubmitting(false);
    }
  };

  // Tab Navigation Component
  const TabNavigation = () => (
    <nav className="tab-navigation" data-testid="tab-navigation">
      <button 
        className={`tab-btn ${activeTab === 'home' ? 'active' : ''}`}
        onClick={() => setActiveTab('home')}
      >
        Home
      </button>
      <button 
        className={`tab-btn ${activeTab === 'linings' ? 'active' : ''}`}
        onClick={() => setActiveTab('linings')}
      >
        London Linings
      </button>
      <button 
        className={`tab-btn ${activeTab === 'serveai' ? 'active' : ''}`}
        onClick={() => setActiveTab('serveai')}
      >
        Serve AI
      </button>
      <button 
        className={`tab-btn ${activeTab === 'music' ? 'active' : ''}`}
        onClick={() => setActiveTab('music')}
      >
        Music
      </button>
    </nav>
  );

  // HOME TAB - About Jay London
  const HomeTab = () => (
    <div className="tab-content home-tab" data-testid="home-tab">
      <div className="hero-section">
        <div className="logo-container">
          <img src={jlLogoUrl} alt="JL Logo" className="jl-logo-image" />
        </div>
        <h1 className="artist-name">JAY LONDON</h1>
        <p className="role-subtitle">
          ENTREPRENEUR&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;FOUNDER&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;DJ&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;PRODUCER
        </p>
        <p className="tagline">Building businesses. Creating music. Making an impact.</p>
        
        <div className="social-links">
          <a href="https://www.instagram.com/jaylondon.au/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
            <InstagramIcon />
          </a>
          <a href="https://www.tiktok.com/@jay.london.au" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="TikTok">
            <TikTokIcon />
          </a>
          <a href="https://www.linkedin.com/in/jaylondon" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
            <LinkedInIcon />
          </a>
          <a href="https://www.youtube.com/@JayLondonau" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
            <YouTubeIcon />
          </a>
        </div>
      </div>

      {/* About Section */}
      <div className="about-section">
        <div className="gold-divider">
          <span className="divider-line"></span>
          <span className="divider-icon">★</span>
          <span className="divider-line"></span>
        </div>
        
        <div className="about-content">
          <div className="artist-image-container">
            <img src={jayLondonKeysImage} alt="Jay London" className="artist-image" />
          </div>
          <div className="about-text-container">
            <p className="about-text">
              Melbourne-based entrepreneur and creative, Jay London builds premium service businesses 
              and creates music that moves. From transforming garages with <span className="text-highlight">London Linings</span> to 
              automating businesses with <span className="text-highlight">Serve AI</span>, and producing tracks heard on 
              <span className="text-highlight"> BBC Radio worldwide</span>.
            </p>
          </div>
        </div>
      </div>

      {/* Venture Cards */}
      <div className="ventures-section">
        <h2 className="section-title">What I Do</h2>
        
        <div className="venture-cards">
          <div className="venture-card" onClick={() => setActiveTab('linings')}>
            <img src={londonLiningsLogo} alt="London Linings" className="venture-logo" />
            <h3 className="venture-name">London Linings</h3>
            <p className="venture-desc">Premium Epoxy Flooring Melbourne</p>
            <span className="venture-link">Explore <ExternalLinkIcon /></span>
          </div>

          <div className="venture-card" onClick={() => setActiveTab('serveai')}>
            <div className="serve-text-logo">
              <span className="serve-text">SERVE AI</span>
            </div>
            <h3 className="venture-name">Serve AI</h3>
            <p className="venture-desc">AI Automation for Service Businesses</p>
            <span className="venture-link">Explore <ExternalLinkIcon /></span>
          </div>

          <div className="venture-card" onClick={() => setActiveTab('music')}>
            <img src={goldDiggerGirlArtwork} alt="Music" className="venture-logo music-artwork" />
            <h3 className="venture-name">Music</h3>
            <p className="venture-desc">DJ / Producer / Songwriter</p>
            <span className="venture-link">Explore <ExternalLinkIcon /></span>
          </div>
        </div>
      </div>
    </div>
  );

  // LONDON LININGS TAB
  const LiningsTab = () => (
    <div className="tab-content linings-tab" data-testid="linings-tab">
      <div className="venture-header">
        <img src={londonLiningsLogo} alt="London Linings" className="venture-header-logo" />
        <p className="venture-tagline">Premium Epoxy Flooring in Melbourne</p>
        <a href="https://www.londonlinings.com.au" target="_blank" rel="noopener noreferrer" className="visit-site-btn">
          Visit Website <ExternalLinkIcon />
        </a>
      </div>

      <div className="venture-content">
        <div className="gold-divider">
          <span className="divider-line"></span>
          <span className="divider-icon">◆</span>
          <span className="divider-line"></span>
        </div>

        <p className="venture-overview">
          London Linings provides premium epoxy flooring across Melbourne's most exclusive suburbs. 
          Using high-grade Australian materials and advanced grinding techniques, we deliver seamless, 
          durable finishes trusted by homeowners and builders from Balwyn to Brighton.
        </p>

        <div className="services-grid">
          <div className="service-card">
            <img src={epoxyFloorImage} alt="Residential Epoxy" className="service-image" />
            <h4>Residential Epoxy</h4>
            <p>Transform your garage into a showroom</p>
          </div>
          <div className="service-card">
            <img src={commercialEpoxy} alt="Commercial Epoxy" className="service-image" />
            <h4>Commercial Epoxy</h4>
            <p>Durable solutions for business spaces</p>
          </div>
          <div className="service-card">
            <img src={grindAndSeal} alt="Grind and Seal" className="service-image" />
            <h4>Grind & Seal</h4>
            <p>Premium concrete finishing</p>
          </div>
        </div>

        <div className="feature-highlights">
          <div className="highlight">
            <span className="highlight-icon">✓</span>
            <span>3-Day Premium Install</span>
          </div>
          <div className="highlight">
            <span className="highlight-icon">✓</span>
            <span>10+ Year Durability</span>
          </div>
          <div className="highlight">
            <span className="highlight-icon">✓</span>
            <span>Australian Materials</span>
          </div>
          <div className="highlight">
            <span className="highlight-icon">✓</span>
            <span>Trusted by Builders</span>
          </div>
        </div>

        <a href="https://www.londonlinings.com.au/contact-us/" target="_blank" rel="noopener noreferrer" className="cta-btn">
          Get A Free Quote
        </a>
      </div>
    </div>
  );

  // SERVE AI TAB
  const ServeAITab = () => (
    <div className="tab-content serveai-tab" data-testid="serveai-tab">
      <div className="venture-header">
        <div className="serve-text-logo header-logo">
          <span className="serve-text">SERVE AI</span>
        </div>
        <p className="venture-tagline">Smart AI Websites & CRM for Service Businesses</p>
        <a href="https://www.serveai.com.au" target="_blank" rel="noopener noreferrer" className="visit-site-btn">
          Visit Website <ExternalLinkIcon />
        </a>
      </div>

      <div className="venture-content">
        <div className="gold-divider">
          <span className="divider-line"></span>
          <span className="divider-icon">◆</span>
          <span className="divider-line"></span>
        </div>

        <p className="venture-overview">
          Serve AI is an AI systems consultancy that builds smart websites connected to CRM, 
          ensuring enquiries, bookings, follow-ups, and client data flow seamlessly across your entire business. 
          Stop losing customers to slow replies and manual processes.
        </p>

        <div className="services-grid serve-services">
          <div className="service-card serve-card">
            <h4>Serve AI</h4>
            <p>Consultancy & System Design</p>
            <span className="service-detail">We assess how your business operates and design the right AI, CRM and automation systems.</span>
          </div>
          <div className="service-card serve-card">
            <h4>Serve CRM</h4>
            <p>Automation & Smart Websites</p>
            <span className="service-detail">Enquiries, follow-ups, pipelines, messaging - all tracked in one place with automated replies.</span>
          </div>
          <div className="service-card serve-card">
            <h4>Serve Media</h4>
            <p>Content & Video Assets</p>
            <span className="service-detail">Professional video and content for your website and social platforms.</span>
          </div>
        </div>

        <div className="industries-section">
          <h4 className="industries-title">Industries We Serve</h4>
          <div className="industries-list">
            <span className="industry-tag">Tradies</span>
            <span className="industry-tag">Finance</span>
            <span className="industry-tag">Medical</span>
            <span className="industry-tag">Real Estate</span>
            <span className="industry-tag">Legal</span>
            <span className="industry-tag">Consultancy</span>
          </div>
        </div>

        <a href="https://www.serveai.com.au/contactus/" target="_blank" rel="noopener noreferrer" className="cta-btn">
          Book Free Strategy Call
        </a>
      </div>
    </div>
  );

  // MUSIC TAB
  const MusicTab = () => (
    <div className="tab-content music-tab" data-testid="music-tab">
      {/* OUT NOW Banner */}
      <div className="out-now-banner">
        <div className="banner-scroll">
          <span>OUT NOW • GOLD DIGGER GIRL • JAY LONDON • STREAMING WORLDWIDE • </span>
          <span>OUT NOW • GOLD DIGGER GIRL • JAY LONDON • STREAMING WORLDWIDE • </span>
        </div>
      </div>

      <div className="music-hero">
        <p className="music-subtitle">DJ / PRODUCER / SONGWRITER</p>
        <p className="music-tagline">Modern sound. Cinematic energy. Music that moves.</p>
        
        <div className="social-links music-socials">
          <a href="https://open.spotify.com/album/6EZvFBzxTPPso3FZApyM2v" target="_blank" rel="noopener noreferrer" className="social-link">
            <SpotifyIcon />
          </a>
          <a href="https://music.apple.com/au/album/gold-digger-girl/1880396157?i=1880396158&l=en-GB" target="_blank" rel="noopener noreferrer" className="social-link">
            <AppleMusicIcon />
          </a>
          <a href="https://www.youtube.com/@JayLondonau" target="_blank" rel="noopener noreferrer" className="social-link">
            <YouTubeIcon />
          </a>
          <a href="https://www.tiktok.com/@jay.london.au" target="_blank" rel="noopener noreferrer" className="social-link">
            <TikTokIcon />
          </a>
        </div>
      </div>

      {/* Latest Release */}
      <div className="latest-release">
        <div className="release-badge">
          <span className="sparkle">✦</span> NEW SINGLE <span className="sparkle">✦</span>
        </div>
        
        <div className="release-artwork-container">
          <div className="artwork-glow"></div>
          <img src={goldDiggerGirlArtwork} alt="Gold Digger Girl" className="release-artwork" />
        </div>
        
        <h2 className="release-title">Gold Digger Girl</h2>
        <p className="release-date">STREAMING NOW</p>
        
        <div className="stream-buttons">
          <a href="https://open.spotify.com/album/6EZvFBzxTPPso3FZApyM2v" target="_blank" rel="noopener noreferrer" className="stream-btn spotify-btn">
            <SpotifyIcon /> Play on Spotify
          </a>
          <a href="https://music.apple.com/au/album/gold-digger-girl/1880396157?i=1880396158&l=en-GB" target="_blank" rel="noopener noreferrer" className="stream-btn apple-btn">
            <AppleMusicIcon /> Apple Music
          </a>
        </div>

        <div className="song-preview">
          <p className="preview-label">PREVIEW THE HOOK</p>
          <video controls className="preview-player" poster={goldDiggerGirlArtwork}>
            <source src={songPreviewClip} type="video/mp4" />
          </video>
        </div>
      </div>

      {/* Radio Support */}
      <div className="radio-section">
        <div className="gold-divider">
          <span className="divider-line"></span>
          <span className="divider-icon">📻</span>
          <span className="divider-line"></span>
        </div>
        <h3 className="section-title">Global Radio Support</h3>
        <p className="section-subtitle">Gold Digger Girl is spinning worldwide</p>
        
        <div className="radio-stations-compact">
          <span className="station">🇬🇧 BBC Radio</span>
          <span className="station">🇩🇪 Chart-Tipps.de</span>
          <span className="station">🇬🇷 Kiss FM 89</span>
          <span className="station">🇦🇺 radio.sydney</span>
          <span className="station">🇺🇸 Big Hits Radio NY</span>
          <span className="station">🇳🇱 Radio-Cor</span>
          <span className="station">🇪🇸 Antena Caro</span>
          <span className="station">🇭🇷 Radio Rab</span>
        </div>
      </div>

      {/* Challenge Section */}
      <div className="challenge-section">
        <div className="challenge-card">
          <div className="platform-header">
            <TikTokIcon />
            <InstagramIcon />
            <FacebookIcon />
          </div>
          <h3 className="challenge-title">#GoldDiggerGirlChallenge</h3>
          <div className="challenge-steps">
            <p><span className="check-icon">✓</span> POST YOUR VERSION</p>
            <p><span className="check-icon">✓</span> DO A DANCE</p>
            <p><span className="check-icon">✓</span> SING THE CHORUS</p>
          </div>
          <div className="tshirt-showcase">
            <img src={tshirtImage} alt="Prize T-Shirt" className="tshirt-image" />
          </div>
          <div className="prize-section">
            <p className="prize-headline">TOP 5 VIDEOS WIN</p>
            <p className="prize-text">EXCLUSIVE MERCH</p>
          </div>
        </div>
        
        <div className="challenge-buttons">
          <a href="https://www.tiktok.com/@jay.london.au" target="_blank" rel="noopener noreferrer" className="platform-btn">
            <TikTokIcon /> Join on TikTok
          </a>
          <a href="https://www.instagram.com/jaylondon.au/" target="_blank" rel="noopener noreferrer" className="platform-btn">
            <InstagramIcon /> Join on Instagram
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <div className="app-container" data-testid="jay-london-portfolio">
      {/* Background */}
      <div className="background-image"></div>
      <div className="background-overlay"></div>
      
      {/* Gold Particles */}
      <div className="gold-particles">
        {[...Array(15)].map((_, i) => (
          <div key={i} className="gold-particle" style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${4 + Math.random() * 4}s`
          }}></div>
        ))}
      </div>

      {/* Main Content */}
      <main className={`main-content ${isLoaded ? 'loaded' : ''}`}>
        {/* Tab Navigation */}
        <TabNavigation />

        {/* Tab Content */}
        {activeTab === 'home' && <HomeTab />}
        {activeTab === 'linings' && <LiningsTab />}
        {activeTab === 'serveai' && <ServeAITab />}
        {activeTab === 'music' && <MusicTab />}

        {/* Email Signup - Only on Home */}
        {activeTab === 'home' && (
          <div className="email-signup">
            {!emailSubmitted ? (
              <>
                <h3 className="signup-title">Stay in the Loop</h3>
                <p className="signup-subtitle">Get updates on new ventures and releases</p>
                <form onSubmit={handleEmailSubmit} className="signup-form">
                  <input 
                    type="email" 
                    placeholder="Your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="signup-input"
                    required
                    disabled={isSubmitting}
                  />
                  <button type="submit" className="signup-btn" disabled={isSubmitting}>
                    {isSubmitting ? '...' : 'Subscribe'}
                  </button>
                </form>
              </>
            ) : (
              <div className="signup-success">
                <span className="success-icon">✓</span>
                <p>You're on the list!</p>
              </div>
            )}
          </div>
        )}

        {/* Footer */}
        <footer className="footer">
          <div className="footer-content">
            <p className="footer-brand">JAY LONDON</p>
            <div className="footer-links">
              <a href="mailto:jaylondon.au@gmail.com" className="footer-link">Contact</a>
              <span className="footer-divider">•</span>
              <a href="mailto:jaylondon.au@gmail.com?subject=Press%20Enquiry%20-%20Jay%20London" className="footer-link">Press Enquiries</a>
              <span className="footer-divider">•</span>
              <a href="https://www.instagram.com/jaylondon.au/" target="_blank" rel="noopener noreferrer" className="footer-link">Instagram</a>
              <span className="footer-divider">•</span>
              <a href="https://www.linkedin.com/in/jaylondon" target="_blank" rel="noopener noreferrer" className="footer-link">LinkedIn</a>
            </div>
            <p className="copyright">© 2026 Jay London. All rights reserved.</p>
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;
